import { StrictMode, Suspense } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import type { JSX, PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Toaster } from 'sonner'

import B2becSpinner from '@/components/B2becSpinner'
import { ErrorFallback } from '@/components/ErrorFallback'
import store from '@/store/store'
import { queryClient } from '@/libs/queryClient'

import ThemeProvider from './theme-provider'

export function AppProvider({ children }: PropsWithChildren): JSX.Element {
  return (
    <StrictMode>
      <Suspense fallback={<B2becSpinner isLoading />}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <QueryClientProvider client={queryClient}>
            <NuqsAdapter>
              <BrowserRouter>
                <Provider store={store}>
                  <ThemeProvider>
                    {children}
                    <Toaster
                      richColors
                      position="top-right"
                      duration={3750}
                      visibleToasts={3}
                      toastOptions={{
                        style: {
                          fontSize: '16px',
                        },
                      }}
                    />
                    <ReactQueryDevtools initialIsOpen={false} />
                  </ThemeProvider>
                </Provider>
              </BrowserRouter>
            </NuqsAdapter>
          </QueryClientProvider>
        </ErrorBoundary>
      </Suspense>
    </StrictMode>
  )
}
